import copy from '../copy/en/intake.json' with { type: 'json' };

/** Editable presentation aliases; pinned source values remain unchanged. */
export function nativeOptionLabel(key: string, value: string): string {
  if (key === 'operations.intraoralScanner') {
    if (value === "I don't have an intraoral scanner") return copy.scannerNone;
    if (value === "I' looking for an intraoral scanner") return copy.scannerLooking;
  }
  if (key === 'financial.processingFee') {
    if (value === 'WAY TOO MUCH!') return copy.processingFeeFivePlus;
    if (/^\d*\.?\d+%$/.test(value)) return `${Number.parseFloat(value)}%`;
  }
  return value;
}
